import React from 'react';
import LoginForm from '../../components/auth/LoginForm';
const Login = () => {
  return <div className="w-full py-16 bg-gray-100" data-id="element-602">
      <div className="container mx-auto px-4" data-id="element-603">
        <LoginForm data-id="element-604" />
      </div>
    </div>;
};
export default Login;